import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Common, PupilProgress } from "../../helper"
import { setPupilInfo } from "../../store/pupilProgressSlice";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const ClassHomeTable = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pupil } = props;
  const handlePupilClick = (pupil)=>{
    dispatch(setPupilInfo(pupil))
    navigate(PupilProgress.lineGraph)
  }
  return (
    <div className='classHomeTable-container'>
      <table className="your-table-class">
        <thead>
          <tr>
            <th scope="col" className='your-table-class th' ></th>
          </tr>
        </thead>
        <tbody className='classHomeSubjectBody'>
          <tr id='your-table-class-empty-tr'>
            <td id='your-table-class-empty'>

            </td>
          </tr>
          <tr id="classHomeClassAverage-tr">
            <td id='your-table-class-td'>
              <span className='classAverageSpan'>{Common.ClassAverage}</span>
            </td>
          </tr>
          {pupil && pupil.map((n) => (
            <tr key={n.id} className='your-table-class tr'>
              <td className='d-flex flex-column your-table-class td'>
                <span className='classHome-name' onClick={()=>handlePupilClick(n)} onKeyDown={(e) => { e.key === "Enter" && handlePupilClick(n) }} tabIndex={0} role="button"><u>{`${n.firstName} ${n.lastName}`}</u></span>
                <div className=' d-flex flex-row'>
                  {Object.entries(n?.others).map(([key, value]) => (
                    value && (
                      <div className="senStatus" key={key}>
                        <div className="dot" style={{ background: key === "pupilPremium" ? "#6D47FF" : key === "eal" ? "#F4C900" : key === "ehcp" || key === "senStatus" ? "#F50057" : "" }}></div>
                        <span className="nameText">{key === "pupilPremium" ? "PP" : key === "senStatus" ? "SEND" : key === "ehcp" ? "EHCP" : key === "eal" ? "EAL" : ""}</span>
                      </div>
                    )
                  ))}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { ClassHomeTable };
